import PropTypes from 'prop-types'
import React, { Component, useContext, useState, createRef } from 'react'
import { BrowserRouter, Route, Link } from 'react-router-dom';
import { dbClicks } from '../firebase'
import { AppState } from '../context';
import emailPush from './EmailKeeper'

import {
  Ref,
  Rail,
  Sticky,
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
  Dropdown,
  Dimmer,
  Form
} from 'semantic-ui-react'
import EmailReader from './EmailKeeper';
import ModalBlogLogin from './ModalBlogLogin';

// const someContext = useContext(AppState);
//const [logged, setLogged] = useState(false);
// const {
//   clicks,
// } = someContext;
// Heads up!
// We using React Static to prerender our docs with server side rendering, this is a quite simple solution.
// For more advanced usage please check Responsive docs under the "Usage" section.
const getWidth = () => {
  const isSSR = typeof window === 'undefined'

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
}
// function writeFirebase(){
//   var temp=clicks['getstarted']+1;
//   dbClicks.child('getstarted')
// }

/* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container text>
    <Header
      as='h1'
      content='How you can help your parents during this tough time'
      inverted
      style={{
        fontSize: mobile ? '2em' : '4em',
        fontWeight: 'normal',
        marginBottom: 0,
        marginTop: mobile ? '1.5em' : '3em',
      }}
    />

  </Container>
)

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
}

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {}

  hideFixedMenu = () => this.setState({ fixed: false })
  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { children } = this.props
    const { fixed } = this.state

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign='center'
            style={{ minHeight: 700, padding: '1em 0em' }}
            vertical
          >
            <Menu
              fixed={fixed ? 'top' : null}
              inverted={!fixed}
              pointing={!fixed}
              secondary={!fixed}
              size='large'
            >
              <Container>
                <Menu.Item href='/' fluid>
                  Home
                </Menu.Item>
                <Menu.Item href='/blog' fluid>
                  Blog
                </Menu.Item>
                <Menu.Item href='/tutorial' fluid>
                  How It Works
                </Menu.Item>
                <Menu.Item href='/zipcoderesources' fluid active>
                  COVID-19 resources
          </Menu.Item>
          <Menu.Item href='/contactus' fluid>
                                                Contact Us
                </Menu.Item>

                {/* <Menu.Item as='a'>Work</Menu.Item>
                <Menu.Item as='a'>Company</Menu.Item>
                <Menu.Item as='a'>Careers</Menu.Item> */}
                {/* <Menu.Item position='right'>
                  <Button as='a' inverted={!fixed}>
                    Log in primary family members
                  </Button>
                  <Button as='a' inverted={!fixed} primary={fixed} style={{ marginLeft: '0.5em' }}>
                    Log in secondary family members
                  </Button>
                  <Button as='a' inverted={!fixed} primary={fixed} style={{ marginLeft: '0.5em' }}>
                    Log in caregivers
                  </Button>
                </Menu.Item> */}
              </Container>
            </Menu>
            <HomepageHeading />
          </Segment>
        </Visibility>

        {children}
        <Segment style={{ padding: '4em 0em' }} vertical>
          <Grid container >
            <Grid.Row>
              <Grid.Column width={14}>
                <Header as='h3' style={{ fontSize: '2em' }}>
                  About us
          </Header>
                <p style={{ fontSize: '1.33em' }}>
                  We are a Northwestern based start-up radically innovating the way we care.
          </p>
                <Header as='h3' style={{ fontSize: '2em' }}>
                  Contact Us:
          </Header>
                <p style={{ fontSize: '1.33em' }}>
                  Reach out to us anytime at homecarenuvention@gmail.com and we will set up a time to chat to talk more about our product and our mission statement. You can also
                  call or send a text at (312)-934-9963. Or just enter your email here to be part of our mailing list:
          </p>
                {/* </Grid.Column> */}
              </Grid.Column>
            </Grid.Row>


            <Grid.Row>
              <Grid.Column textAlign='center'>
                <a href="//utkarshmishra2022.typeform.com/to/m7wknd" target="_blank"><Button size='huge'>Register</Button></a>
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </Segment>
        <Segment inverted vertical style={{ padding: '5em 0em' }}>
          <Container>
            <Grid divided inverted stackable>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header inverted as='h4' content='Follow us' />
                  <List link inverted>
                    <a href="//facebook.com/homecareapp" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Facebook</List.Item></a>
                    <a href="//twitter.com/Homecare_app" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Twitter</List.Item></a>
                    <a href="//instagram.com/homecare_nu" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Instagram</List.Item></a>
                    {/* <Hyperlink linkStyle={{ color: '#2980b9', fontSize: 20 }}
                <div style={{ fontSize: 15 }}>
                  Make clickable strings like https://github.com/obipawan/hyperlink stylable
  </div>
              </Hyperlink> */}

                    {/* <List.Item as='a'>Gazebo Plans</List.Item> */}
                  </List>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header inverted as='h4' content='Contact us' />
                  <List link inverted>
                    <List.Item>homecarenuvention@gmail.com</List.Item>
                    {/* <List.Item as='a'>How To Access</List.Item>
              <List.Item as='a'>Favorite X-Men</List.Item> */}
                  </List>
                </Grid.Column>
                <Grid.Column width={7}>
                  <Header as='h4' inverted>
                    Homecare
            </Header>
                  <p>
                    Help us help you care.
            </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </Responsive>
    )
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
}

const Menuu = () => {
  const [activeItem, setCity] = useState(0);
  const optionsZip = [
    {
      key: 0,
      text: "60440",
      value: 0
    },
    {
      key: 1,
      text: "60490",
      value: 1
    },
    {
      key: 2,
      text: "60540",
      value: 2
    },
    {
        key: 3,
        text: "60564",
        value: 3
      },
      {
        key: 4,
        text: "60565",
        value: 4
      },
      {
        key: 5,
        text: "60566",
        value: 5
      },
      {
        key: 6,
        text: "60567",
        value: 6
      },
// the first 7 are Naperville area
{key: 7,
text: "60201",
value: 7},
{key: 9,
    text: "60202",
    value: 9},
    {key: 10,
        text: "60203",
        value: 10},
        {key: 11,
            text: "60204",
            value: 11},
{key: 8,
    text: "60208",
    value: 8},
    {key: 12,
        text: "60209",
        value: 12},

// evanston zip codes
      {
        key: 22,
        text: "New York",
        value: 22
      },

      // the first 7 zip codes are naperville area
  ]
  const DropdownExampleSearchSelection = () => (
    <Dropdown
      placeholder='Enter/Select ZipCode'
      fluid
      search
      selection
      options={optionsZip}
      onChange={(e, { value }) => {
          console.log(value)
          setCity(value)
        }}

      
    />
  )
  return (
      <div>
            <DropdownExampleSearchSelection />
            {activeItem < 7 ? 
            <Naperville></Naperville> : activeItem < 13 ? 
            <Evanston></Evanston> : activeItem < 20?
            <Chicago></Chicago> : <NewYork></NewYork>}

    </div>
  )

}

class MobileContainer extends Component {
  state = {}

  handleSidebarHide = () => this.setState({ sidebarOpened: false })

  handleToggle = () => this.setState({ sidebarOpened: true })

  render() {
    const { children } = this.props
    const { sidebarOpened } = this.state

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation='push'
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item href='/'>
            Home
          </Menu.Item>
          <Menu.Item href='/blog'>
            Blog
          </Menu.Item>
          <Menu.Item href='/tutorial' fluid>
                  How It Works
          </Menu.Item>
          <Menu.Item href='/zipcoderesources' fluid active>
                  COVID-19 resources
          </Menu.Item>
          {/* <Menu.Item href='/requestdemo' fluid>
                  Request Demo
                </Menu.Item> */}
                   <Menu.Item href='/contactus' fluid>
                                                Contact Us
                </Menu.Item>
          <Menu.Item as={Link} to={'/familymembers'}>Log in families</Menu.Item>

          <Menu.Item as={Link} to={'/caregivers'}>Log in caregiver</Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign='center'
            style={{ minHeight: 350, padding: '1em 0em' }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size='large'>
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name='sidebar' />
                </Menu.Item>
              </Menu>
            </Container>
            <HomepageHeading mobile />
          </Segment>
          {children}
        </Sidebar.Pusher>
        <Divider />
        <Segment style={{ padding: '4em 0em', marginTop: "-20px" }} vertical>
          <Grid container >
            <Grid.Row>
              <Grid.Column width={14}>
                <Header as='h3' style={{ fontSize: '2em' }}>
                  About us
          </Header>
                <p style={{ fontSize: '1.33em' }}>
                  We are a Northwestern based start-up radically innovating the way we care.
          </p>
                <Header as='h3' style={{ fontSize: '2em' }}>
                  Contact Us:
          </Header>
                <p style={{ fontSize: '1.33em' }}>
                  Reach out to us anytime at homecarenuvention@gmail.com and we will set up a time to chat to talk more about our product and our mission statement. You can also
                  call or send a text at (312)-934-9963. Or just enter your email here to be part of our mailing list:
          </p>
                {/* </Grid.Column> */}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column textAlign='center'>
                <a href="//utkarshmishra2022.typeform.com/to/m7wknd" target="_blank"><Button size='huge'>Register</Button></a>
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </Segment>
        <Segment inverted vertical style={{ padding: '5em 0em' }}>
          <Container>
            <Grid divided inverted stackable>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header inverted as='h4' content='Follow us' />
                  <List link inverted>
                    <a href="//facebook.com/homecareapp" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Facebook</List.Item></a>
                    <a href="//twitter.com/Homecare_app" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Twitter</List.Item></a>
                    <a href="//instagram.com/homecare_nu" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Instagram</List.Item></a>
                    {/* <Hyperlink linkStyle={{ color: '#2980b9', fontSize: 20 }}
                <div style={{ fontSize: 15 }}>
                  Make clickable strings like https://github.com/obipawan/hyperlink stylable
  </div>
              </Hyperlink> */}

                    {/* <List.Item as='a'>Gazebo Plans</List.Item> */}
                  </List>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header inverted as='h4' content='Contact us' />
                  <List link inverted>
                    <List.Item>homecarenuvention@gmail.com</List.Item>
                    {/* <List.Item as='a'>How To Access</List.Item>
              <List.Item as='a'>Favorite X-Men</List.Item> */}
                  </List>
                </Grid.Column>
                <Grid.Column width={7}>
                  <Header as='h4' inverted>
                    Homecare
            </Header>
                  <p>
                    Help us help you care.
            </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </Responsive>
    )
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
}

const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </div>
)

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
}

const ZipCodeFinder = () => {


  return (<ResponsiveContainer>
    <ModalBlogLogin />
    <Segment style={{ padding: '4em 0em' }} vertical>
      <Grid container >
        {/* <Grid.Row>
          <Grid.Column width={14}> */}
        <p style={{ fontSize: '1.33em' }}>
          During these times, the elderly population is not only the most vulnerable to Coronavirus but also its effect on daily lifestyles. In metropolitan areas, even when the eventual stay-at-home order is indeed lifted, there will still be strict (and necessary) guidelines for seniors. Here’s information that you as a family member of the elderly can share with them or use to ensure they can get their food needs met during these times.
            </p>
            <p style={{ fontSize: '1.2em' }}>
          Bookmark this page. If you want to share your story or resources contact us at homecarenuvention@gmail.com.          
            </p>
            
            <br />
           {/* <EmailReader/> */}
          
        {/* </Grid.Column>
        </Grid.Row> */}
        <Menuu></Menuu>
      </Grid>
    </Segment>

  </ResponsiveContainer>)
}

const Naperville = () => {
    const contextRef = createRef();
    return (
      <Ref innerRef={contextRef}>
  
        <Segment style={{ padding: '3em 0em' }} vertical >
          {/* <Sticky active={false} context={contextRef}>
     <Rail position='top'>
    
                    <Image src='https://react.semantic-ui.com/images/wireframe/image.png' />
                  
                </Rail>
                </Sticky> */}
          <Grid.Row>
            <Grid.Column width={16} >
              <Header as='h3' style={{ fontSize: '1.63em' }} >Ensuring food needs are met
          </Header>
            </Grid.Column>
          </Grid.Row>
          {/* <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Senior Centers
            </Header>
              <p style={{ fontSize: '1.30em' }}>
                If your parent is 60+, you may know that senior centers have already been closed. However, a few centers (found <a href="//www1.nyc.gov/site/dfta/services/find-help.page" target="_blank">here</a>) are still operational in providing lunches every weekday from 11:00 am to 1:00 pm. If an aide will be going to pick up meals, they should definitely try to communicate with the center in advance. The NYCFoodPolicy organization also recommends asking about the following before visiting a local center: meal delivery, the hours of operation, and the possibility of extra meals.
          </p>
            </Grid.Column>
          </Grid.Row> */}
          <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Special Supermarket Operating Hours for Seniors
          </Header>
              <p style={{ fontSize: '1.30em' }}>
              Aldi 8:30-9:30 a.m. Tuesday and Thursday
            <br></br>

                Butera – 7-9 a.m. everyday
                <br></br>

            Angelo Caputo’s – 6-7 a.m. Tuesday Wednesday Thursday
            <br></br>

Costco – 8-9 a.m. Tuesday and Thursday
<br></br>

Fresh Thyme – 6-8 a.m. Monday Wednesday Friday
<br></br>

H Mart – 9-10 a.m. everyday
<br></br>

Jewel-Osco – 7-9 a.m. Tuesday and Thursday
<br></br>

Marianos – 6-8 a.m. everyday
<br></br>

Target – 8-9 a.m. Wednesday
<br></br>

Trader Joe’s – 9-10 a.m.
<br></br>

Walgreens – 8-9 a.m. Tuesday
<br></br>

Walmart – 6-7 a.m. Tuesday
<br></br>

Whole Foods – 8-9 a.m. everyday
                
            </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Food Resources
  </Header>
              <p style={{ fontSize: '1.30em' }}>
                Loaves and Fishes: Tuesday/Thursday: 9am - 12 pm, Saturday: 8am-11:30 am. Must be residents of Naperville or DuPage County to receive food once in a 7-day period in a drive-thru model. Find more information <a href="https://www.loaves-fishes.org/covid-19/" target="_blank">here.</a> TEL: (630) 355-3663
                <br />
                Lisle Township for Lisle Township Residents Only: The Pantry is open M-W-F 8:30am to 11:30am and 2:00pm to 4:00pm. Drive up to the food pantry at 4711 Indiana Ave and have your ID ready. Staff will bring out pre-packed bags of food to the vehicle. General & Emergency Assistance is also continuing as an essential service, by appointment only. Email laura@lisletownship.com and she will call you back to set up a time for your intake. Find more information <a href="https://www.lisletownship.com/covid-19-updates/">here</a> Tel: (630) 968-2087 
                <br />
                Greenharvest.org: Plainfield-based, serves Naperville residents. Those wishing to become clients. MUST CALL 630-416-1109 or emailcontact@greenharvest.orgYou will not be allowed tojust show up. ALL FOOD DISTRIBUTION IS DONE BY APPOINTMENT ONLY! We will continue our normal shopping day Tuesday’s and Thursday’s at regular appointed times.Clients will not be able to shop, but will be able to pick up bags of assorted foods and personal hygiene items. Find more <a href="https://www.greenharvest.org/" > here</a>.  Tel: (815) 416-1109.
                <br></br>
                DuPage Senior Council: Serves the seniors in DuPage County as well as some surrounding communities with in home meal delivery and so much more. Here's their <a href="https://www.dupageseniorcouncil.org/home-delivered-meals-menus/">menu</a> and contact them at TEL: (630) 620-0804.
                <br></br>
                Other Resources: Calvary Church Food and Clothing Pantry (TEL: (630) 585-3232), St. Thomas the Apostle (TEL: (630) 355-8980), and Senior Services of Will County Meals on Wheels (TEL: (815) 723-9713).
                </p>
            </Grid.Column>
          </Grid.Row>
  
          <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Other Services (i.e. Homecare)
  </Header>
              <p style={{ fontSize: '1.30em', marginBottom: "-50px" }}>
                If you are managing care for your parents during this time, the Homecare app is the simplest solution for streamlined communication
                and task management. Know not only if but also when tasks are completed. No longer is it necessary to text back and forth with caregivers
                or your siblings. Find out more <a href="/" target="_blank"> <u>here</u></a>.
  
          </p>
            </Grid.Column>
          </Grid.Row>
        </Segment>
      </Ref>
    )
  }
  const Evanston = () => {
    const contextRef = createRef();
    return (
      <Ref innerRef={contextRef}>
  
        <Segment style={{ padding: '3em 0em' }} vertical >
          {/* <Sticky active={false} context={contextRef}>
     <Rail position='top'>
    
                    <Image src='https://react.semantic-ui.com/images/wireframe/image.png' />
                  
                </Rail>
                </Sticky> */}
          <Grid.Row>
            <Grid.Column width={16} >
              <Header as='h3' style={{ fontSize: '1.63em' }} >Ensuring food needs are met
          </Header>
            </Grid.Column>
          </Grid.Row>
          {/* <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Senior Centers
            </Header>
              <p style={{ fontSize: '1.30em' }}>
                If your parent is 60+, you may know that senior centers have already been closed. However, a few centers (found <a href="//www1.nyc.gov/site/dfta/services/find-help.page" target="_blank">here</a>) are still operational in providing lunches every weekday from 11:00 am to 1:00 pm. If an aide will be going to pick up meals, they should definitely try to communicate with the center in advance. The NYCFoodPolicy organization also recommends asking about the following before visiting a local center: meal delivery, the hours of operation, and the possibility of extra meals.
          </p>
            </Grid.Column>
          </Grid.Row> */}
          <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Special Supermarket Operating Hours for Seniors
          </Header>
              <p style={{ fontSize: '1.30em' }}>
                  
              Aldi 8:30-9:30 a.m. Tuesday and Thursday
            <br></br>

                Butera – 7-9 a.m. everyday
                <br></br>
                Valli Produce – Tuesdays and Thursdays from 6:00am-8:00am are designated for seniors beginning March 31 @ 1910 Dempster Street.
<br></br>

Costco – 8-9 a.m. Tuesday and Thursday
<br></br>

Jewel-Osco – 7-9 a.m. Tuesday and Thursday @ the following locations:  2485 Howard St,  1128 Chicago Ave,  1763 Howard St
<br></br>


Target – 7-9 a.m. Wednesday
<br></br>

Trader Joe’s – 9-10 a.m.
<br></br>

Walgreens – 8-9 a.m. Tuesday
<br></br>

Whole Foods – 8-9 a.m. Everyday @ 2748 Green Bay Rd, (847) 424-5700 and 1640 Chicago Ave, Evanston, (847) 733-1600.

            </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Food Resources
  </Header>
              <p style={{ fontSize: '1.30em' }}>

              The Levy Center and Fleetwood-Jourdain Community Center's Congregate Meal Program will continue to provide meals to seniors registered for the programs. Seniors unable to leave their homes may arrange for someone else to pick up meals for them. Please call 847-448-4311 to make arrangements.        
                <br> 
                </br>
               Chefs For Seniors: Located at the North Shore Chi Suburbs, the head chef Samantha Robbins (312-702-1297). Get a quote <a href="https://chefsforseniors.com/chicago-north-shore#block-ddde18682418982b6434">here</a>, and some locations offer contactless delivery as well.
                <br></br>
                Jennifer's Edibles, Inc: They have been toiling to deliver meals to Evanston's seniors and most vulnerable residents. If you need a meal, Text 224-717-1835 after 9 a.m. each day.
                <br></br>
                Feast and Imbibe and Soul and Smoke, 1601 Payne Street: These guys have been giving out free individually packaged meals for the past week to anyone in need in the community. If you'd like a meal, email team@soulandsmoke.com or call 847-859-2732. 
                
                Other Resources: Calvary Church Food and Clothing Pantry (TEL: (630) 585-3232), St. Thomas the Apostle (TEL: (630) 355-8980), and Senior Services of Will County Meals on Wheels (TEL: (815) 723-9713).
               
               
                </p>
                {/* <br />
                Jen’s Guesthouse: striving to help the community and will be providing free meals delivered to seniors
and free soup carry-out to all.  Call them at 708-839-8000 to place an order and
stop by to pick up a free quart of soup and read more on them at <a href="https://www.jensguesthouse.com/blog/free-meals-free-delivery/">here.</a>
                <br> */}
            </Grid.Column>
          </Grid.Row>
  
          <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Other Services (i.e. Homecare)
  </Header>
              <p style={{ fontSize: '1.30em', marginBottom: "-50px" }}>
                If you are managing care for your parents during this time, the Homecare app is the simplest solution for streamlined communication
                and task management. Know not only if but also when tasks are completed. No longer is it necessary to text back and forth with caregivers
                or your siblings. Find out more <a href="/" target="_blank"> <u>here</u></a>.
  
          </p>
            </Grid.Column>
          </Grid.Row>
        </Segment>
      </Ref>
    )
  }

const NewYork = () => {
  const contextRef = createRef();
  return (


    <Ref innerRef={contextRef}>

      <Segment style={{ padding: '3em 0em' }} vertical >
        {/* <Sticky active={false} context={contextRef}>
   <Rail position='top'>
  
                  <Image src='https://react.semantic-ui.com/images/wireframe/image.png' />
                
              </Rail>
              </Sticky> */}
        <Grid.Row>
          <Grid.Column width={16} >
            <Header as='h3' style={{ fontSize: '1.63em' }} >Ensuring food needs are met
        </Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={14}>
            <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
              Senior Centers
          </Header>
            <p style={{ fontSize: '1.30em' }}>
              If your parent is 60+, you may know that senior centers have already been closed. However, a few centers (found <a href="//www1.nyc.gov/site/dfta/services/find-help.page" target="_blank">here</a>) are still operational in providing lunches every weekday from 11:00 am to 1:00 pm. If an aide will be going to pick up meals, they should definitely try to communicate with the center in advance. The NYCFoodPolicy organization also recommends asking about the following before visiting a local center: meal delivery, the hours of operation, and the possibility of extra meals.
        </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={14}>
            <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
              Special Supermarket Operating Hours for Seniors
        </Header>
            <p style={{ fontSize: '1.30em' }}>
              Costco: Open from 8 am to 9 am on Tuesdays and Thursdays for individuals over 60. Find a store <a href="//www.costco.com/warehouse-locations" target="_blank">here</a>.
              Dollar General: Opens 1 hour early for seniors. Find a store <a href="//www.dollargeneral.com/store-locator.html" target="_blank">here.</a>
              Fairway Market: Open from 8 am to 9 am to individuals over 65, as well as others with increased risk to serious illness and expecting mothers. Find a store <a href="//www.fairwaymarket.com/store-locator/" target="_blank">here.</a>
              Target: First shopping hour on Wednesdays is kept for seniors. Find a store <a href="//www.target.com/store-locator/find-stores/new%20york,ny" target="_blank">here</a>.
              Trader Joe’s: From 9 am to 10 am there is a reserved line for seniors to guarantee expedited service. Find a store <a href="//www.traderjoes.com/stores?q=" target="_blank">here</a>.
        </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={14}>
            <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
              Non-Profit Delivery Services
</Header>
            <p style={{ fontSize: '1.30em' }}>
              CityMeals on Wheels:  Provides delivered meals to those over 60 years old with some other eligibility requirements found <a href="https://www.citymeals.org/get-meals" target="_blank">here.</a>
              For example, they requires a Case Manager. You can find more on their remarkable work at the end of the article.
              God’s Love We Deliver: Provides delivered meals to eligible individuals, mostly those who are not well enough to cook or shop
              by themselves. Eligibility requirements and application information found <a href="https://www.glwd.org/get-meals/for-you-or-your-loved-ones/" target="_blank">here.</a>
              If there are any more questions, please reach out to us at homecarenuvention@gmail.com or contact info@nycfoodpolicy.org.
              Alternatively, you can also call Emergency Food Hotline: 866-888-8777 or the Housing Assistance line: 311.
        </p>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={14}>
            <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
              Other Services (i.e. Homecare)
</Header>
            <p style={{ fontSize: '1.30em', marginBottom: "-50px" }}>
              If you are managing care for your parents during this time, the Homecare app is the simplest solution for streamlined communication
              and task management. Know not only if but also when tasks are completed. No longer is it necessary to text back and forth with caregivers
              or your siblings. Find out more <a href="/" target="_blank"> <u>here</u></a>.

        </p>
          </Grid.Column>
        </Grid.Row>
      </Segment>
    </Ref>
  )
}

const Chicago = () => (
  <Segment style={{ padding: '3em 0em' }} vertical>
    <Grid.Row>
      <Grid.Column width={16} >
        <Header as='h3' style={{ fontSize: '1.63em' }} >Ensuring food needs are met
        </Header>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
          Chicago State Government Home Delivery
          </Header>
        <p style={{ fontSize: '1.30em' }}>
          Chicago State Government’s Home Delivered Meals Program: This effort provides nutritious meals to older persons (60 years and older) who are “frail and/or home bound because of illness or incapacitating disability or are otherwise isolated.” Seniors can both register by contacting 312-744-4016 any time between 9 a.m. – 5 p.m., Monday-Friday. See listing and contact information <a href="//www.chicago.gov/content/dam/city/depts/fss/supp_info/SeniorServices/HDM/HDMprojectlistbypsa080119.pdf" target="_blank"><u>here</u></a>. As context, the Meals on Wheels Chicago program works as a partner of this program and has delivered over 61,000 Emergency Meals this year, providing each client with 5 days of meals.

{/* /content/dam/city/depts/fss/supp_info/SeniorServices/HDM/HDMprojectlistbypsa080119.pdf */}
        </p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
          Salvation Army Chicago
        </Header>
        <p style={{ fontSize: '1.30em' }}>

          Their congregate senior and community meals that were occurring daily or weekly are now providing meals in to-go boxes or working with food delivery as necessary. The locations of this pickup and delivery options can be found
<a href="//centralusa.salvationarmy.org/metro/news/salvation-army-food-pantries-open-throughout-division/" target="_blank"> <u>here</u> </a> and you can contact them <a href="//centralusa.salvationarmy.org/metro/emergency-assistance-and-homelessness-prevention/" target="_blank"> <u>here</u> </a>.
        </p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
          Greater Chicago Food Depository:
</Header>
        <p style={{ fontSize: '1.30em' }}>
          Serves anyone in need of food assistance can turn to the Food Depository’s network of agencies and programs by modifying distributions to promote social distancing, including offering pre-packaged boxes of groceries. To reach them, contact  call 773-843-5416 on Mondays-Fridays between 8:30 a.m. and 5 p.m.

        </p>
      </Grid.Column>
    </Grid.Row>

    <Grid.Row>
      <Grid.Column width={14}>
        <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
          Other Services (i.e. Homecare)
</Header>
        <p style={{ fontSize: '1.30em', marginBottom: "-50px" }}>
          If you are managing care for your parents during this time, the Homecare app is the simplest solution for streamlined communication and task management. Know not only if but also when tasks are completed. No longer is it necessary to text back and forth with caregivers or your siblings. Find out more <a href="/" target="_blank"> <u>here</u></a>.
        </p>
      </Grid.Column>
    </Grid.Row>
  </Segment>
)


export default ZipCodeFinder;